import { Component, OnDestroy, OnInit } from '@angular/core';
import { EboiStateService } from 'src/app/service/eboi-state.service';
import { Constants } from '../../constants';
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { VersionCheckService } from 'src/app/service/cache.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  navlinks = this.constants.navLinkItems;
  userName: any = '';
  rolesArray = [];
  fgaDetails: FGAData | null = null;
  private subscription: Subscription;
  highlightHome = false;
  selected = new FormControl();
  currentIndex: any = 0;
  constructor(private readonly constants: Constants, private readonly eboiStateService: EboiStateService, private readonly versionCheckService: VersionCheckService) { }

  ngOnInit(): void {
    this.selected.setValue(1);
    this.toggler('planning');
    this.subscription = this.eboiStateService.getDetails().subscribe(details => {
      this.fgaDetails = details;
      console.info('[Header] FGA details received:', details);
      if (this.fgaDetails) {
        this.userName = localStorage.getItem('name');
        const userName_ = this.fgaDetails?.user?.firstName + ' ' + this.fgaDetails?.user?.lastName;
        let roles = []
        this.rolesArray = [];
        roles = this.fgaDetails?.roles
        if (roles?.length) {
          roles.forEach(e => {
            this.rolesArray.push(e.displayName)
          })
        }
      }
    });
    this.versionCheckService.initVersionCheck();
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace(environment.LIOS_HOME_URL);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onTabClick(index: number) {
    localStorage.setItem('currentIndex', index.toString());
  }

  navigate(url: any) {
    const _url = environment.LIOS_HOME_URL + url;
    console.log("_url_ ", _url)
    // this.router.navigateByUrl(_url);
    window.location.href = _url;
  }

  navigateExternalUrl(url: any) {
    window.location.href = url;
  }

  navigateExternalUrlNewWin(url: any) {
    window.open(url);
  }

  toggler(pageHeader: string): void {
    if (
      pageHeader.includes('home') ||
      pageHeader === '' ||
      pageHeader === '#'
    ) {
      this.highlightHome = true;
    } else {
      this.highlightHome = false;
    }
  }

}
